import { SET_ROLES } from "../ConstAction";

const initialState = {};
export const LoginData = (state = initialState, action) => {

  switch (action.type) {

    case SET_ROLES:
      return {
        ...state,
        roleData: action.response.data,
      };
    default:
      return {
        ...state,
      };
  }
};
